<template>
  <div class="coal__wrapper">
    <p class="coal__title f-ui-1-bold" v-if="title">{{ title }}</p>
    <p class="coal__value f-ui-1">
      <span v-if="change === 0">{{ value }} Mtce</span>
    </p>
    <div
      class="coal__year f-ui-1-bold"
      :class="{ [`color-${color}`]: color }"
      v-if="year"
    >
      {{ year }}
    </div>
    <div
      class="coal__change f-ui-1-bold"
      :class="{ [`color-${color}`]: color }"
      v-if="change"
    >
      {{ change * 100 }}%
    </div>
    <div class="coal__container">
      <div
        class="coal__pile"
        :class="{ [`tint-${color}`]: color }"
        :style="{ top: `${((max - value) / max - change) * 50}px` }"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    value: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
    change: {
      type: Number,
      default: 0,
    },
    year: {
      type: String,
      required: false,
    },
    color: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.coal__wrapper {
  display: inline-block;
  position: relative;
  width: 200px;
  height: 128px;
  background: #fff;
}
.coal__container {
  display: block;
  width: 200px;
  height: 76px;
  overflow: hidden;
  position: absolute;
  bottom: 0px;
  border-bottom: 1px solid black;
}
.coal__pile {
  position: absolute;
  content: " ";
  width: 128px;
  height: 76px;
  left: 36px;
  background-image: url(https://iea.imgix.net/3f86f1ab-a353-4ada-872a-f6064dbb1f9d/coal_pile.png);
  transition: top 0.3s ease-in;
}
p.coal__title,
p.coal__value {
  text-align: center;
  margin-bottom: 0px;
}
.coal__year {
  position: absolute;
  left: 0;
  top: 0;
  transform: rotate(-90deg) translate(-100%, 0);
  transform-origin: top left;
}
.coal__change {
  width: 100%;
  text-align: center;
}
/* Tints */
.tint-STEPS {
  filter: sepia(100%) saturate(200%) brightness(70%) hue-rotate(145deg);
}
.tint-APS {
  filter: sepia(100%) saturate(200%) brightness(70%) hue-rotate(330deg);
}
.tint-NZE {
  filter: sepia(100%) saturate(200%) brightness(70%) hue-rotate(80deg);
}
</style>